import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import { Router } from '@angular/router';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})

export class SignInComponent implements OnInit {
  userName = ""; userPassword = "";
  constructor(
    public authService: AuthService,
    public router: Router
  ) { }

  ngOnInit() {
    // setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);

    if (this.authService.isLoggedIn) {
      this.router.navigateByUrl("/dashboard");
    }
  }
  signIn() {
  //  console.log(this.userName);
    this.authService.SignIn(this.userName, this.userPassword)
  }
}